import type { ReactNode } from 'react';

import { List, ListItem } from '@myphx-engineering/phx-design-system';

export type DeliveryStepProps = {
    stepTexts: Array<
        | string
        | {
              key: string;
              value: ReactNode;
          }
    >;
};

export const DeliveryStep = ({ stepTexts }: DeliveryStepProps) => (
    <List type="ordered">
        {stepTexts.map((step) => {
            if (typeof step === 'string') {
                return <ListItem key={step}>{step}</ListItem>;
            }

            return <ListItem key={step.key}>{step.value}</ListItem>;
        })}
    </List>
);
